var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkEdit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7913_79833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7913_79833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6924 3C14.1975 3.00003 14.6246 3.17542 14.9746 3.52539C15.3246 3.87536 15.5 4.30251 15.5 4.80762V6.5H19.6924C20.1975 6.50003 20.6246 6.67542 20.9746 7.02539C21.3246 7.37536 21.5 7.80251 21.5 8.30762V14H20V8.30762C20 8.23067 19.9675 8.16064 19.9033 8.09668C19.8394 8.03255 19.7693 8.00004 19.6924 8H4.30762C4.23067 8.00004 4.16064 8.03255 4.09668 8.09668C4.03255 8.16064 4.00004 8.23067 4 8.30762V18.6924C4.00004 18.7693 4.03255 18.8394 4.09668 18.9033C4.16064 18.9675 4.23067 19 4.30762 19H15V20.5H4.30762C3.80251 20.5 3.37536 20.3246 3.02539 19.9746C2.67542 19.6246 2.50003 19.1975 2.5 18.6924V8.30762C2.50003 7.80251 2.67542 7.37536 3.02539 7.02539C3.37536 6.67542 3.80251 6.50003 4.30762 6.5H8.5V4.80762C8.50003 4.30251 8.67542 3.87536 9.02539 3.52539C9.37536 3.17542 9.80251 3.00003 10.3076 3H13.6924ZM10.3076 4.5C10.2307 4.50004 10.1606 4.53255 10.0967 4.59668C10.0325 4.66064 10 4.73067 10 4.80762V6.5H14V4.80762C14 4.73067 13.9675 4.66064 13.9033 4.59668C13.8394 4.53255 13.7693 4.50004 13.6924 4.5H10.3076Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5843V20.3859C16 20.2823 16.0191 20.182 16.0574 20.0849C16.0959 19.9878 16.1562 19.898 16.2385 19.8156L20.7784 15.2977C20.8878 15.1883 21.006 15.1113 21.1329 15.0667C21.2598 15.0222 21.3867 15 21.5135 15C21.6519 15 21.7857 15.0259 21.9151 15.0777C22.0445 15.1296 22.1621 15.2075 22.2679 15.3114L23.0821 16.1339C23.1768 16.2435 23.2502 16.362 23.3021 16.4895C23.354 16.617 23.38 16.7445 23.38 16.872C23.38 16.9994 23.3563 17.1292 23.3089 17.2612C23.2615 17.3933 23.1859 17.514 23.0821 17.6234L18.5642 22.1412C18.4819 22.2237 18.3922 22.2841 18.2951 22.3223C18.1978 22.3608 18.0974 22.38 17.9939 22.38H16.7955C16.57 22.38 16.3811 22.3037 16.2286 22.1512C16.0762 21.9987 16 21.8098 16 21.5843ZM17.0494 21.3306H17.8856L20.7427 18.4596L20.3383 18.0415L19.9285 17.6287L17.0494 20.4944V21.3306ZM20.3383 18.0415L19.9285 17.6287L20.7427 18.4596L20.3383 18.0415Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkEdit1);
export default __webpack_public_path__ + "static/media/work_edit1.c09c249ef9dd19cceedad82b1e9bbd52.svg";
export { ForwardRef as ReactComponent };